import clsx from 'clsx'
import { useEffect } from 'react'
import PropTypes from 'prop-types'

/**
 * Ported from pitstop-ui/src/components/EForm/FormField/cell-textarea.jsx
 *
 * Changes:
 *   - `classnames` → `clsx`
 *   - isReadOnly controlled from outside via prop
 */

const INPUT_BASE =
  'box-border w-full type-body-2 text-grey-10 border border-grey-90 rounded-[5px] bg-white shadow-none transition-[border-color] duration-150 ease-in-out appearance-none focus:border-theme-50 focus:outline-none disabled:text-grey-50 disabled:cursor-not-allowed disabled:pointer-events-none disabled:bg-grey-98'

function getClassName(error) {
  return clsx(
    INPUT_BASE,
    'h-auto min-h-[120px] py-3 px-[14px] resize-y [font-family:inherit] [font-size:inherit]',
    error && 'border-red-50 focus:border-red-50'
  )
}

const CellTextareaComponent = ({
  error,
  isReadOnly,
  schema,
  payload,
  parentProps,
  inputProps,
  setInputProps,
  updatePayload,
  validateSchema,
  getFieldValue,
}) => {
  useEffect(() => {
    setInputProps({
      ...inputProps,
      disabled: isReadOnly,
      placeholder: isReadOnly ? null : schema.description || schema.title || '',
      value: getFieldValue(payload, parentProps) ?? '',
    })
  }, [payload, isReadOnly])

  function onChange(e) {
    if (isReadOnly) return
    const value = e.target.value
    setInputProps({ ...inputProps, value })
    updatePayload(value)
    validateSchema(value)
  }

  const currentLength = (inputProps?.value ?? '').length
  const maxLength = schema.maxLength

  return (
    <div className="relative w-full">
      <textarea
        data-testid="eform-textarea"
        className={getClassName(error)}
        disabled={isReadOnly}
        placeholder={inputProps?.placeholder}
        value={inputProps?.value ?? ''}
        onChange={onChange}
        maxLength={maxLength || undefined}
        rows={4}
      />
      {maxLength && !isReadOnly && (
        <div className="mt-1 text-grey-50 text-[12px]" data-testid="eform-textarea-counter">
          {currentLength}/{maxLength}
        </div>
      )}
    </div>
  )
}

CellTextareaComponent.propTypes = {
  error: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  schema: PropTypes.object,
  payload: PropTypes.object,
  parentProps: PropTypes.array,
  inputProps: PropTypes.object,
  setInputProps: PropTypes.func,
  updatePayload: PropTypes.func,
  validateSchema: PropTypes.func,
  getFieldValue: PropTypes.func,
}

export default CellTextareaComponent
